import { JourneyApi } from './journey.api';

const journeyApi = new JourneyApi();

export { journeyApi };
